module.exports = __webpack_public_path__ + "img/logo.a5b7e027.png";